/**
 * Labstep
 *
 * @module components/Entity/Action/Edit
 * @desc Button to edit entity
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type React from 'react';
import type { EntityActionEditProps } from './types';

export const EntityActionEdit: React.FC<EntityActionEditProps> = ({
  entity,
  actionComponentProps,
  renderIfNoEditPermissions,
  dataCy,
}) => {
  const canEdit = useHasAccess(
    entity.entityName,
    entity.idAttr,
    Action.edit,
  ) as boolean;

  if (!canEdit && !renderIfNoEditPermissions) {
    return null;
  }

  return (
    <ActionComponent
      dataCy={dataCy}
      type="option"
      text="Edit"
      icon="pencil"
      disabled={!canEdit}
      {...actionComponentProps}
    />
  );
};
